/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_MethodInputs */

const cs_field_method = /** @type {(inputs: Field_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda`)
};

const en_field_method = /** @type {(inputs: Field_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Method`)
};

/**
* | output |
* | --- |
* | "Method" |
*
* @param {Field_MethodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_method = /** @type {((inputs?: Field_MethodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_MethodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_method(inputs)
	return cs_field_method(inputs)
});